import { string, bool } from 'prop-types';

import themeColors from 'styles/themes/colors';

/** Define the shape of the Placeholder Mask */
const Placeholder = ({
  entityType,
  isVersion,
  placeholderGradientId,
  forBreadcrumb,
}) => {
  if (isVersion) {
    switch (entityType) {
      case 'release':
      case 'list':
      case 'track':
        return (
          <>
            <rect
              fillRule="evenodd"
              fill={themeColors.NightBlue}
              fillOpacity="0.075"
              x="5"
              y="5"
              width="90"
              height="90"
              rx="3"
            />
            <rect
              fillRule="evenodd"
              fill={`url(#${placeholderGradientId})`}
              x="20"
              y="20"
              width="60"
              height="60"
              rx="3"
            />
          </>
        );
      default:
        return null;
    }
  } else {
    switch (entityType) {
      case 'release':
      case 'list':
      case 'track':
        return (
          <rect
            fill={`url(#${placeholderGradientId})`}
            fillRule="evenodd"
            x="5"
            y="5"
            width="90"
            height="90"
            rx="3"
          />
        );
      case 'artist':
      case 'label':
        return (
          <circle
            cx={forBreadcrumb ? 15 : 50}
            cy={forBreadcrumb ? 15 : 50}
            r={forBreadcrumb ? 15 : 50}
            fill={`url(#${placeholderGradientId})`}
            fillRule="evenodd"
          />
        );
      case 'project':
        return (
          <>
            <path
              transform="translate(5,5)"
              d="M2,0 L42,0 L42,90 L2,90 C0.8954305,90 0,89.1045695 0,88 L0,2 C0,0.8954305 0.8954305,0 2,0 Z"
              fill={`url(#${placeholderGradientId}_1)`}
              fillRule="evenodd"
            />
            <path
              transform="translate(5,5)"
              d="M48,0 L88,0 C89.1045695,0 90,0.8954305 90,2 L90,42 L48,42 L48,0 Z M48,48 L90,48 L90,88 C90,89.1045695 89.1045695,90 88,90 L48,90 L48,48 Z"
              fill={`url(#${placeholderGradientId}_2)`}
              fillRule="evenodd"
            />
          </>
        );
      default:
        return null;
    }
  }
};

Placeholder.propTypes = {
  entityType: string.isRequired,
  isVersion: bool,
  forBreadcrumb: bool,
  placeholderGradientId: string,
};

export default Placeholder;
